import Breadcrumb from '../components/Breadcrumb';
import { BiSolidEditAlt } from 'react-icons/bi';
import { IoNewspaperOutline, IoSearchSharp } from 'react-icons/io5';
import { useEffect, useRef, useState, useContext } from 'react';
// import { Datepicker } from '@ijavad805/react-datepicker';
import { FaDeleteLeft } from 'react-icons/fa6';
import { TiDelete, TiTick } from 'react-icons/ti';
// import DatePanel from 'react-multi-date-picker/plugins/date_panel';
import DatePicker from 'react-multi-date-picker';
import persian from 'react-date-object/calendars/persian';
import persian_fa from 'react-date-object/locales/persian_fa';
import { LuDelete } from 'react-icons/lu';
import { CiEdit } from 'react-icons/ci';
import { MdDeleteForever } from 'react-icons/md';
// import { InputDatePicker  } from "jalaali-react-date-picker";
// import "jalaali-react-date-picker/lib/styles/index.css";
import { AiFillEdit } from 'react-icons/ai';

import { format as jalaliFormat, toDate } from 'date-fns-jalali';
import { FaRegWindowClose } from 'react-icons/fa';
import axios from 'axios';
import { json, Link, useSearchParams } from 'react-router-dom';
import ReactPaginate from 'react-paginate';
import { BsChevronLeft, BsChevronRight } from 'react-icons/bs';
import SearchLawDropDown from '../SearchableDropDown/SearchLawDropDown';
import { DataContext } from '../context/DataProvider';
import SearchableDropDownApprovalauthority from '../SearchableDropDown/SearchableDropDownApprovalauthority';
import LawType from '../SearchableDropDown/LawType';
import e from 'express';
import SearchableDropDownApprovalauthority2 from '../SearchableDropDown/SearchableDropDownApprovalauthority2';
import { jwtDecode } from 'jwt-decode';
import Loader from '../common/Loader';

const Specificationslaw = () => {
  const {
    OptionSearch,
    orgId,
    orgId2,
    isTokenExpired,
    tokenLogin,
    fetchRefreshToken,
    ValueForSearch,
    TypeList,
    setTypeList,
    TypeIDList,
    setTypeIDList,
    caseDataSpecialLaw, setcaseDataSpecialLaw
  }: any = useContext(DataContext);
  function deHilight(str) {
    return str
      .replaceAll(/\n/g, ' ')
      .replaceAll('</e>', ' ')
      .replaceAll('</b>', ' ')
      .replaceAll('<e>', ' ')
      .replaceAll('<b>', ' ')
      .replaceAll(' ', '  ');
  }
  const DivRef = useRef();
  const [SearchText, setSearchText] = useState('');

  const [fromDate, setFromDate] = useState<null | Date | string>(null);
  const [ToDate, setToDate] = useState<null | Date | string>(null);
  const [openCeateModal, setOpenCreateModal] = useState(false);
  const [savePage, setSavePage] = useState(1);
  const [open, setOpen] = useState(false);
  const [pageSize, setPageSize] = useState(30);
  const [pageSizeSearch, setPageSizeSearch] = useState(30);
  const [pageNumber, setPageNumber] = useState(1);
  const [pageNumberSearch, setPageNumberSearch] = useState(1);
  const [searchParams, setsearchParams] = useSearchParams();
  const [ListLaw, setListLaw] = useState([]);
  const [ListLawCount, setListLawCount] = useState(1);
  const [LawForEdit, setLawForEdit] = useState({});
  const [Type, setType] = useState<number | null>(8);
  // const [TypeIDList, setTypeIDList] = useState([]);
  // const [Search, setSearch] = useState('');
  const [SearchResult, setSearchResult] = useState([]);
  const [Loading, setLoading] = useState(true);
  const Role = jwtDecode(tokenLogin.data?.accessToken);
  // console.log(Role)
  // const [TypeList, setTypeList] = useState([]);
  const [SearchResultCount, setSearchResultCount] = useState(1);
  const page: number | any = searchParams.get('page');
  let rowNumber = page ? (page - 1) * pageSize : 0;
  // const [caseData, setcaseData] = useState({
  //   // date: jalaliFormat(new Date(), 'yyyy/MM/dd'),
  //   date: '',
  //   title: '',
  //   id: 0,
  //   ApprovalAuthority: null,
  //   lawtypeID: 0,
  //   typeID: 0,
  //   IsReplated: null,
  //   isChecked: null,
  //   ApproveDate2: '',
  //   ApproverID2: null,
  // });

  const [LawTypeTitle, setLawTypeTitle] = useState({});
  const [isReplated, setIsReplated] = useState<boolean | null>(false);
  const [FindIDInfoFetch,setFindIDInfoFetch]=useState([])
  //   const FetLawType=async()=>{
  // await fetch(`${process.env.REACT_APP_BASE_URL}/api/Data/Get?id=3`).then((res)=>res.json()).then((data)=>setTypeList(data))
  //   }
  const handleChangeSize = (e) => {
    // console.log('size', e.target.value);
    if (page !== 1) {
      setsearchParams({});
      setPageSize(parseInt(e.target.value));
    } else {
      setPageSize(parseInt(e.target.value));
    }
    // fetchListRelation(page=1)
    // if (e.target.value === "null") {
    //   setPageSize(10)
    // }
    // else {
    //   setPageSize(parseInt(e.target.value))
    // }
  };
  const [IsEdit, setIsEdit] = useState(false);
  const [date, setDate] = useState();
  const handleApproveDate2 = (date: any) => {
    if (date == null) {
      setcaseDataSpecialLaw((caseDataSpecialLaw) => ({
        ...caseDataSpecialLaw,
        ApproveDate2: null,
      }));
    } else {
      setcaseDataSpecialLaw((caseDataSpecialLaw) => ({
        ...caseDataSpecialLaw,
        ApproveDate2: jalaliFormat(new Date(date), 'yyyy/MM/dd'),
      }));
    }
  };
  // console.log(caseData.ApproveDate2)
  const handleDate = (date: any) => {
    if (date == null) {
      setcaseDataSpecialLaw((caseDataSpecialLaw) => ({
        ...caseDataSpecialLaw,
        date: null,
      }));
    } else {
      setcaseDataSpecialLaw((caseDataSpecialLaw) => ({
        ...caseDataSpecialLaw,
        date: jalaliFormat(new Date(date), 'yyyy/MM/dd'),
      }));
    }
  };
  // console.log(caseData.date)

  const OnchangeIsChecked = (e: any) => {
    // console.log(e.target.value);
    if (e.target.value == 'null') {
      setcaseDataSpecialLaw((caseDataSpecialLaw) => ({
        ...caseDataSpecialLaw,
        isChecked: null,
      }));
    } else if (e.target.value == 'true') {
      setcaseDataSpecialLaw((caseDataSpecialLaw) => ({
        ...caseDataSpecialLaw,
        isChecked: true,
      }));
    } else {
      setcaseDataSpecialLaw((caseDataSpecialLaw) => ({
        ...caseDataSpecialLaw,
        isChecked: false,
      }));
    }
  };
  const FetchLawList = async (pageNum: number) => {
    // console.log("fetchListLaw",isReplated)
    setLoading(true);
    setcaseDataSpecialLaw({
      date: '',
      title: '',
      id: 0,
      ApprovalAuthority: null,
      lawtypeID: 0,
      typeID: 0,
      IsReplated: null,
      isChecked: null,
      ApproveDate2: '',
      ApproverID2: null,
    });
    try {
      const response = await axios.get(
        `${
          process.env.REACT_APP_BASE_URL
        }/api/Admin/ListLaw?size=${pageSize}&page=${
          page == null ? '1' : page
        }&lawType_ID=8${isReplated !== null ? '&repealed=' + isReplated : ''}`,
      );
      const data = response.data.data;
      setListLaw(data);
      setListLawCount(response.data.count);
      setLoading(false);
      setSearchResult([]);
      // setSavePage(1);
      // setPageNumber(1);
      setSearchResultCount(1);
      // rowNumber = 0;
    } catch (error) {
      console.log('err', error);
    }
  };
  const SearchFun = async () => {
    // console.log("object",isReplated)
    if (
      Type !== 8 ||
      fromDate !== null ||
      ToDate !== null ||
      SearchText !== '' ||
      isReplated !== null
    ) {
      // console.log("searchFun")
      setLoading(true);
      try {
        // setLoading(true)
        const response = await axios.get(
          `${
            process.env.REACT_APP_BASE_URL
          }/api/Admin/ListLaw?size=${pageSize}&page=${
            page == null ? '1' : page
          }${SearchText !== '' ? '&search=' + SearchText : ''}${
            fromDate !== null ? '&fromDate=' + fromDate : ''
          }${ToDate !== null ? '&toDate=' + ToDate : ''}${
            Type !== null ? '&lawType_ID=' + Type : ''
          }${isReplated !== null ? '&repealed=' + isReplated : ''}`,
        );
        // console.log(response.data);
        const data = response.data.data;

        setSearchResult(data);
        setSearchResultCount(response.data.count);
        setLoading(false);
      } catch (error) {
        console.log('err', error);
      }
    } else {
      FetchLawList(page ? page : 1);
    }


  };

  const handleFromDate = (date: Date) => {
    if (date !== null) {
      // console.log('true');
      setFromDate(jalaliFormat(new Date(date), 'yyyy/MM/dd'));
    } else {
      setFromDate(null);
      setsearchParams({});
      setSavePage(1);
      setPageNumber(1);
    }
  };
  const handleToDate = (date: Date) => {
    if (date !== null) {
      setToDate(jalaliFormat(new Date(date), 'yyyy/MM/dd'));
    } else {
      setToDate(null);
      setsearchParams({});
      setSavePage(1);
      setPageNumber(1);
    }
  };
  const changeType = (e) => {
    if (e.target.value == 'null') {
      setType(null);
    } else {
      setType(Number(e.target.value));
      setsearchParams({});
      setSavePage(1);
      setPageNumber(1);
    }
  };

  const onPageChange = ({ selected }) => {
    setSavePage(selected + 1);
    setsearchParams({ page: selected + 1 });
    setPageNumber(selected + 1);
    // FetchLawList(selected+1)
  };

  const onPageChangeSearch = ({ selected }) => {
    setSavePage(selected + 1);
    setsearchParams({ page: selected + 1 });
    setPageNumberSearch(selected + 1);
  };
  const isReplatedChecked = async (e) => {
    //   console.log(e.target.checked)
    // setIsReplated(e.target.checked)
    if (e.target.value === 'null') {
      setIsReplated(null);
    } else {
      setIsReplated(e.target.value);
    }
  };
  // console.log(ListLaw);
  useEffect(() => {
    // FetLawType()
    // console.log('object',fromDate);
    // console.log(SearchText)

    if (
      SearchText !== '' ||
      fromDate !== null ||
      ToDate !== null ||
      Type !== 8
    ) {
      SearchFun();
    } else {
      FetchLawList(page ? page : 1);
    }

    // SearchFun()
  }, [page]);
  useEffect(() => {
    if (SearchText == '') {
      SearchFun();
    }
  }, [SearchText]);
  const [EditOption, setEditOpetion] = useState({});
  const EditBtn = async (item) => {
    console.log(item)
    try {
      fetch(
        `${
          process.env.REACT_APP_BASE_URL
        }/api/Admin/ListRelation?search=${item.ID}`,
      )
        .then((res) =>res.json())
        .then((data) => {
          console.log("0",data)
          setFindIDInfoFetch(data.data);
        })
      // const response = await axios.get(
      //   `${process.env.REACT_APP_BASE_URL}/api/Admin/GetLaw?id=${item.ID}`,
      
      // )
      // const res=response.json()
      // setEditOpetion(res.data);
      // console.log(response.data)
    } catch (error) {}
    setcaseDataSpecialLaw({
      ...caseDataSpecialLaw,
      date: item.ApproveDate,
      title: item.Title,
      id: item.ID,
      lawtypeID: item.LawType_ID !== undefined ? item.LawType_ID : null,
      ApprovalAuthority:
        item.Approver_ID !== undefined ||
        item.Approver_ID !== 0 ||
        item.Approver_ID !== 1
          ? item.Approver_ID
          : null,
      typeID: item.Type_ID,
      IsReplated: item.IsRepealed !== null ? item.IsRepealed : null,
      ApproveDate2: item.Approve2Date,
      ApproverID2: item.Approver2_ID !== null ? item.Approver2_ID : null,
      isChecked: item.IsChecked !== null ? item.IsChecked : null,
    });
    setOpen(!open);
    
  };
  // console.log("$$$$$$",FindIDInfoFetch);
  const upsertLawFun = async () => {
    console.log(caseDataSpecialLaw);
    // console.log("DDD",orgId);
    // console.log("www",orgId2);
    setLoading(true);
    if (!isTokenExpired(tokenLogin.data?.accessToken)) {
      try {
        await fetch(`${process.env.REACT_APP_BASE_URL}/api/Admin/UpsertLaw`, {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${tokenLogin.data?.accessToken}`,
            'Content-Type': 'application/json',
            // 'Access-Control-Allow-Origin': '*',
            // 'Access-Control-Allow-Methods': 'GET,OPTIONS,PATCH,DELETE,POST,PUT',
            // 'Access-Control-Allow-Headers':
            //   'X-Requested-With, Content-Type, Authorization',
            // 'Access-Control-Allow-Credentials': 'true',
          },
          body: JSON.stringify({
            ID: caseDataSpecialLaw.id,
            Title: caseDataSpecialLaw.title,
            IsRepealed: caseDataSpecialLaw.IsReplated,
            Approver_ID: caseDataSpecialLaw.ApprovalAuthority,
            ApproveDate: caseDataSpecialLaw.date,
            Type_ID: caseDataSpecialLaw.typeID,
            LawType_ID: caseDataSpecialLaw.lawtypeID,
            IsChecked: caseDataSpecialLaw.isChecked,
            Approver2_ID: caseDataSpecialLaw.ApproverID2,
            Approve2Date: caseDataSpecialLaw.ApproveDate2,
          }),
        }).then((res) => {
          console.log(res.json());
          if (res.status === 200) {
            setLoading(false);
            if (SearchResult.length == 0) {
              FetchLawList(page ? page : 1);
            } else {
              SearchFun();
            }
           
            setEditOpetion({})
            setcaseDataSpecialLaw({
              date: '',
              title: '',
              id: 0,
              ApprovalAuthority: null,
              lawtypeID: 0,
              typeID: 0,
              IsReplated: null,
              isChecked: null,
              ApproveDate2: '',
              ApproverID2: null,
            });
            setOpen(false);
            alert('ویرایش با موفقیت انجام شد');
          }
        });
      } catch (error) {
        console.log('error', error);
      }
    } else {
      fetchRefreshToken();
    }
  };

  // console.log(ListLaw);
  // console.log(caseData);
  if (Loading) return <Loader/>;

  if (tokenLogin == '') {
    window.location.assign('/');
    localStorage.clear();
  }
  console.log(caseDataSpecialLaw);
  return (
    <>
      <Breadcrumb pageName="مشخصات قانون" />

      {/* <!-- ====== Calendar Section Start ====== --> */}
      <div
        id="DivRef"
        className="w-full font-IranSans max-w-full p-10 rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark"
      >
        <div className="w-full md:flex md:items-center md:justify-between">
          {/* <SearchLawDropDown /> */}
          <div className="w-full flex items-center">
            <input
              onChange={(e) => setSearchText(e.target.value)}
              className="border-2 md:w-[90%] w-full relative border-[#E5E1DA] outline-none p-2 rounded-lg  text-[16px]"
              placeholder="جستجوی قانون"
              defaultValue={SearchText}
            />
          </div>
          {/*  <div className="bg-[#FD02] ml-24">
            <button className="button">
              <IoSearchSharp size={35} className="svgIcon " />
            </button>
          </div> */}

          <div className="w-full grid md:grid-cols-5 grid-cols-1 items-center  ">
            {/* date */}
            <div className="w-full  md:mt-0 mt-3 flex items-center ">
              <div className="w-full flex items-center  ">
                <label className="ml-3">از </label>
                <DatePicker
                  className="custom-calendar"
                  inputClass="custom-input"
                  calendarPosition="bottom-center"
                  value={fromDate}
                  locale={persian_fa}
                  calendar={persian}
                  onChange={handleFromDate}
                />
              </div>
            </div>
            <div className="w-full  md:mt-0 mt-3 flex items-center ">
              <div className="w-full flex items-center ">
                <label className="ml-3 md:mr-3">تا </label>
                <DatePicker
                  className="custom-calendar"
                  inputClass="custom-input"
                  calendarPosition="bottom-center"
                  value={ToDate}
                  locale={persian_fa}
                  calendar={persian}
                  onChange={handleToDate}
                />
              </div>
            </div>
            {/* type */}
            <div className="w-full md:mr-3 md:mt-0 mt-3 flex items-center ">
              <LawType changeTypeFun={changeType} type={Type} />
              {/* <select
                onChange={changeType}
                className="border w-[100%] relative border-[#E5E1DA] outline-none p-2 rounded-lg text-[14px]"
               
              >
                <option value="null"></option>
              {TypeList.map((item)=>{
                return item.ID==8 ?<option value={item.ID} selected>{item.Item}</option>:<option value={item.ID}>{item.Item}</option>
              })}
              </select> */}
            </div>
            <div className="flex w-full items-center mt-3 mb-4 ml-3">
              <select
                onChange={isReplatedChecked}
                className="border-2 md:w-[90%] w-full relative border-[#E5E1DA] outline-none p-2 rounded-lg text-[14px]"
                defaultValue={isReplated}
              >
                {isReplated == null ? (
                  <option value="null" selected></option>
                ) : (
                  <option value="null"></option>
                )}
                {isReplated == 'true' ? (
                  <option value="true" selected>
                    نمایش همه منسوخه ها{' '}
                  </option>
                ) : (
                  <option value="true">نمایش همه منسوخه ها </option>
                )}
                {isReplated == 'false' ? (
                  <option value="false" selected>
                    عدم نمایش منسوخه ها{' '}
                  </option>
                ) : (
                  <option value="false">عدم نمایش منسوخه ها </option>
                )}
              </select>

              {/* <input
                           
                            onChange={isReplatedChecked}
                            id="default-checkbox"
                            type="checkbox"
                            value=""
                            className="w-7 h-7 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 dark:bg-gray-700 dark:border-gray-600"
                          />
                            <label
                            for="default-checkbox"
                            class="ms-2 text-sm font-[16px] text-gray-900 dark:text-gray-300 ml-3"
                          >
                           نمایش همه منسوخه ها 
                          </label> */}
            </div>
            {/* button */}
            <div className=" md:mt-0 mt-3 flex items-center">
              <button className="buttonsearch" onClick={SearchFun}>
                <IoSearchSharp size={35} className="svgIcon " />
              </button>
            </div>
          </div>
        </div>
        <div className="w-full mt-3 mb-3">
          <div className="w-full  md:mt-0 mt-3 flex items-center mb-3">
            <div className="w-[20%] mr-3 ml-3">
              {SearchResult.length !== 0
                ? 'نتیجه جستجو :' + SearchResultCount
                : 'نتیجه جستجو :' + ListLawCount}{' '}
            </div>
            <button>
              <div className="box font-IranSans text-[13px]">
                تشخیص هوشمند مشخصات
              </div>
            </button>
            <button
              className=" md:mt-0 mt-3 "
              onClick={() => {
                setOpen(true);
                setcaseDataSpecialLaw({
                  date: '',
                  title: '',
                  id: 0,
                  ApprovalAuthority: null,
                  lawtypeID: 0,
                  typeID: 0,
                  IsReplated: null,
                  isChecked: null,
                  ApproveDate2: '',
                  ApproverID2: null,
                });
                setIsEdit(false);
              }}
            >
              <span className="box font-IranSans text-[16px]">جدید</span>
            </button>
          </div>
        </div>

        <table className="w-full">
          <thead>
            <tr className="font-IranSans w-full bg-[#B1B2FF] text-[#030637]">
              <th className="w-10 border-b p-3 text-[14px] text-center">
                ردیف
              </th>
              <th className="w-[30rem] border-b p-3 text-[14px] text-center">
                عنوان قانون
              </th>
              <th className="w-10 border-b p-3 text-[14px] text-center">
                نوع قانون
              </th>
            </tr>
          </thead>
          <tbody>
            {/* <!-- Line 1 --> */}

            {SearchResult.length !== 0 ? (
              <>
                {SearchResult.map((item, index) => {
                  const x = TypeList.find((i) => i.id == item.LawType_ID);
                  return (
                    <>
                      <tr className="">
                        <td className="w-10 border-b p-3 text-[14px] text-center">
                          {(rowNumber = rowNumber + 1)}
                        </td>
                        <td className="w-[30rem] border-b p-3 text-[14px] ">
                          <Link
                            target="_blank"
                            // to={`https://ilaw.mrc.ir/ViewText/${item.ID}`}
                            to={`https://ilaws.net/ViewText/${item.ID}`}
                          >
                            <span>{item.Title}</span>
                          </Link>
                          <span className="mr-2">{item.ApproveDate}</span>
                        </td>
                        <td className="w-10 border-b p-3 text-[16px] text-center">
                          {x !== undefined ? (
                            <>
                              {' '}
                              <div
                                onClick={() => {
                                  EditBtn(item);
                                  setIsEdit(true);
                                }}
                                className="bg-[#38bdf8] flex items-center justify-center text-[16px] font-IranSans w-[100%] p-2 text-[#ffffff] shadow-md rounded-lg cursor-pointer hover:text-[#38bdf8] border hover:border-[#38bdf8] hover:bg-[#ffffff]"
                              >
                                {x.item}
                                {/* <AiFillEdit className="text-[16px]" /> */}
                              </div>
                            </>
                          ) : (
                            <>
                              {' '}
                              <div
                                onClick={() => {
                                  EditBtn(item);
                                  setIsEdit(true);
                                }}
                                className="bg-[#38bdf8] flex items-center justify-center text-[16px] font-IranSans w-[100%] p-2 text-[#ffffff] shadow-md rounded-lg cursor-pointer hover:text-[#38bdf8] border hover:border-[#38bdf8] hover:bg-[#ffffff]"
                              >
                                <AiFillEdit className="text-[16px]" />
                              </div>
                            </>
                          )}
                        </td>
                      </tr>
                    </>
                  );
                })}
              </>
            ) : (
              <>
                {SearchResultCount == 0 ? (
                  <>
                    <tr className="IranSana grid grid-cols-4">
                      <td className=""></td> <td className=""></td>{' '}
                      <td className=""></td>{' '}
                      <td className="col-end-5 col-start-1">موردی یافت نشد</td>{' '}
                    </tr>
                  </>
                ) : (
                  <>
                    {ListLaw.map((item, index) => {
                      const x = TypeList.find((i) => i.id == item.LawType_ID);
                      return (
                        <>
                          <tr className="">
                            <td className="w-10 border-b p-3 text-[14px] text-center">
                              {(rowNumber = rowNumber + 1)}
                            </td>
                            <td className="w-[30rem] border-b p-3 text-[14px] ">
                              <Link
                                target="_blank"
                                // to={`https://ilaw.mrc.ir/ViewText/${item.ID}`}
                                to={`https://ilaws.net/ViewText/${item.ID}`}
                              >
                                <span>{item.Title}</span>
                              </Link>
                              <span className="mr-2">{item.ApproveDate}</span>
                            </td>
                            <td className="w-10 border-b p-3 text-[16px] text-center">
                              {x !== undefined ? (
                                <>
                                  {' '}
                                  <div
                                    onClick={() => {
                                      EditBtn(item);
                                      setIsEdit(true);
                                    }}
                                    className="bg-[#38bdf8] flex items-center justify-center text-[16px] font-IranSans w-[100%] p-2 text-[#ffffff] shadow-md rounded-lg cursor-pointer hover:text-[#38bdf8] border hover:border-[#38bdf8] hover:bg-[#ffffff]"
                                  >
                                    {x.item}
                                    {/* <AiFillEdit className="text-[16px]" /> */}
                                  </div>
                                </>
                              ) : (
                                <>
                                  {' '}
                                  <div
                                    onClick={() => {
                                      EditBtn(item);
                                      setIsEdit(true);
                                    }}
                                    className="bg-[#38bdf8] flex items-center justify-center text-[16px] font-IranSans w-[100%] p-2 text-[#ffffff] shadow-md rounded-lg cursor-pointer hover:text-[#38bdf8] border hover:border-[#38bdf8] hover:bg-[#ffffff]"
                                  >
                                    <AiFillEdit className="text-[16px]" />
                                  </div>
                                </>
                              )}
                            </td>
                          </tr>
                        </>
                      );
                    })}
                  </>
                )}
              </>
            )}
          </tbody>
        </table>
        <div className="w-full mt-3">
          {SearchResult.length == 0 ? (
            <>
              <div className="w-full grid grid-cols-1 md:flex md:items-center md:justify-between">
                <div className="flex items-center w-full rtl ">
                  <label className="text-[16px]">تعداد نمایش در صفحه </label>
                  <select
                    className="border-b p-1 mr-3 rounded-lg border-gray-400 outline-none"
                    style={{ fontFamily: 'IranSans' }}
                    onChange={handleChangeSize}
                    value={pageSize}
                  >
                    <option value="10">10</option>
                    <option value="30">30</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                    <option value="300">300</option>
                    <option value="500">500</option>
                    <option value="1000">1000</option>
                  </select>
                </div>
                <div className="w-full items-center justify-center">
                  <ReactPaginate
                    breakLabel={<span className="mr-4 sm:mr-0">...</span>}
                    nextLabel={
                      <span className="w-10 h-10 sm:w-5 sm:h-5 flex items-center justify-center bg-[#D3D3D3] rounded-md mr-4 sm:mr-2 sm:p-2">
                        <BsChevronLeft />
                      </span>
                    }
                    onPageChange={onPageChange}
                    pageRangeDisplayed={5}
                    pageCount={
                      ListLawCount !== 0 && Math.ceil(ListLawCount / pageSize)
                    }
                    previousLabel={
                      <span className="w-10 h-10 sm:w-5 sm:h-5 flex items-center justify-center bg-[#D3D3D3] rounded-md">
                        <BsChevronRight />
                      </span>
                    }
                    initialPage={savePage - 1}
                    containerClassName="flex items-center justify-center mt-4 mb-4 flex-wrap"
                    pageClassName="block border- border-solid border-[#D3D3D3] hover:bg-gray-200 w-10 h-10  flex items-center justify-center rounded-md mr-4"
                    activeClassName={
                      savePage ? 'bg-[#06b6d4] text-white hover:text-black' : ''
                    }
                    // current
                  />
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="w-full grid grid-cols-1 md:flex md:items-center md:justify-between">
                <div className="flex ">
                  <label className="text-lg">تعداد نمایش در صفحه </label>
                  <select
                    className="border-b p-1 mr-3 rounded-lg border-gray-400 outline-none"
                    style={{ fontFamily: 'IranSans' }}
                    onChange={handleChangeSize}
                    value={pageSize}
                  >
                    <option value="10">10</option>
                    <option value="30">30</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                    <option value="300">300</option>
                    <option value="500">500</option>
                    <option value="1000">1000</option>
                  </select>
                </div>
                <div className="w-full">
                  <ReactPaginate
                    breakLabel={<span className="mr-4 sm:mr-0">...</span>}
                    nextLabel={
                      <span className="w-10 h-10 sm:w-5 sm:h-5 flex items-center justify-center bg-[#D3D3D3] rounded-md mr-4 sm:mr-2 sm:p-2">
                        <BsChevronLeft />
                      </span>
                    }
                    onPageChange={onPageChangeSearch}
                    pageRangeDisplayed={5}
                    pageCount={
                      SearchResultCount !== 0 &&
                      Math.ceil(SearchResultCount / pageSize)
                    }
                    previousLabel={
                      <span className="w-10 h-10 sm:w-5 sm:h-5 flex items-center justify-center bg-[#D3D3D3] rounded-md">
                        <BsChevronRight />
                      </span>
                    }
                    initialPage={savePage - 1}
                    containerClassName="flex items-center justify-center mt-4 mb-4 flex-wrap"
                    pageClassName="block border- border-solid border-[#D3D3D3] hover:bg-gray-200 w-10 h-10  flex items-center justify-center rounded-md mr-4"
                    activeClassName={
                      savePage !== 0
                        ? 'bg-[#06b6d4] text-white hover:text-black'
                        : ''
                    }
                    // current
                  />
                </div>
              </div>
            </>
          )}
        </div>
        {/* </div>  */}
        {open && (
          <div className="ModalBackground">
            <div className="Modal-innerSpLaw">
              <FaRegWindowClose
                onClick={() => setOpen(false)}
                className="  mb-2 cursor-pointer"
                size={18}
              />
              <div className="border   rounded-md p-5 border-[#cbd5e1]">
                {IsEdit ? (
                  <section className="text-center font-bold">
                    ویرایش {caseDataSpecialLaw.title}{' '}
                  </section>
                ) : (
                  <section className="text-center font-bold">
                    ایجاد قانون جدید
                  </section>
                )}
                <br></br>
                <div className="w-full flex items-center  col-span-1	">
                  <label className="h-full w-[15%] text-[16px] flex items-center  font-IranSans">
                    عنوان :
                  </label>
                  <input
                    type="text"
                    className="w-[85%] border  outline-none  p-2 rounded-md"
                    defaultValue={caseDataSpecialLaw.title}
                    onChange={(e) =>
                      setcaseDataSpecialLaw((caseDataSpecialLaw) => ({
                        ...caseDataSpecialLaw,
                        title: e.target.value,
                      }))
                    }
                  />
                </div>
                <div className="w-full grid grid-cols-2 gap-10 mt-5 ">
                  <div className="w-full flex items-center justify-between">
                    <label className="h-full w-[30%] text-[14px] flex items-center justify-center font-IranSans">
                      مرجع تصویب
                    </label>
                    <SearchableDropDownApprovalauthority
                      organID={caseDataSpecialLaw.ApprovalAuthority}
                    />
                    {/* <select className="w-[70%] border outline-none  p-2 rounded-md">
                      <option></option>
                      <option>1</option>
                      <option>2</option>
                      <option>3</option>
                    </select> */}
                  </div>
                  <div className="w-full flex items-center justify-between">
                    <label className="h-full w-[30%] text-[14px] flex items-center justify-center font-IranSans">
                      مرجع تصویب2
                    </label>
                    <SearchableDropDownApprovalauthority2
                      organID={caseDataSpecialLaw.ApproverID2}
                    />
                    {/* <select className="w-[70%] border outline-none  p-2 rounded-md">
                      <option></option>
                      <option>1</option>
                      <option>2</option>
                      <option>3</option>
                    </select> */}
                  </div>
                  <div className="w-full flex items-center justify-between">
                    <label className="h-full w-[30%] text-[14px] flex items-center font-IranSans">
                      تاریخ تصویب
                    </label>
                    <div className="w-full">
                      <DatePicker
                        className="custom-calendar"
                        inputClass="custom-input"
                        calendarPosition="bottom-center"
                        value={caseDataSpecialLaw.date}
                        locale={persian_fa}
                        calendar={persian}
                        onChange={handleDate}
                      />
                    </div>
                  </div>

                  <div className="w-full flex items-center justify-between">
                    <label className="h-full w-[30%] text-[14px] flex items-center font-IranSans">
                      تاریخ تصویب2
                    </label>
                    <div className="w-full">
                      <DatePicker
                        className="custom-calendar"
                        inputClass="custom-input"
                        calendarPosition="bottom-center"
                        value={caseDataSpecialLaw.ApproveDate2}
                        locale={persian_fa}
                        calendar={persian}
                        onChange={handleApproveDate2}
                      />
                    </div>
                  </div>

                  <div className="w-full flex items-center justify-between">
                    <label className="h-full w-[30%] text-[14px] flex items-center font-IranSans">
                      دسته بندی
                    </label>
                    <div className="w-full">
                      <select
                        onChange={(e) =>
                          setcaseDataSpecialLaw((caseDataSpecialLaw) => ({
                            ...caseDataSpecialLaw,
                            lawtypeID: Number(e.target.value),
                          }))
                        }
                        className="border w-[100%] ml-5 border-[#E5E1DA] outline-none p-2 rounded-lg text-[14px]"
                      >
                        <option></option>
                        {TypeList.map((item) => {
                          return item.id == caseDataSpecialLaw.lawtypeID ? (
                            <option value={item.id} selected>
                              {item.item}
                            </option>
                          ) : (
                            <option value={item.id}>{item.item}</option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                  <div className="w-full flex items-center justify-between">
                    <label className="h-full w-[30%] text-[14px] flex items-center font-IranSans">
                      نوع{' '}
                    </label>
                    <div className="w-full flex ">
                      {TypeIDList.map((item) => {
                        return (
                          <>
                            {item.id == caseDataSpecialLaw.typeID ? (
                              <>
                                {' '}
                                <div className="flex items-center mb-4 ml-3">
                                  <input
                                    defaultChecked
                                    onChange={(e) =>
                                      setcaseDataSpecialLaw((caseDataSpecialLaw) => ({
                                        ...caseDataSpecialLaw,
                                        typeID: Number(e.target.value),
                                      }))
                                    }
                                    id="default-radio-1"
                                    type="radio"
                                    value={item.id}
                                    name="default-radio"
                                    className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300  dark:focus:ring-blue-600 dark:ring-offset-gray-800  dark:bg-gray-700 dark:border-gray-600"
                                  />
                                  <label
                                    for="default-radio-1"
                                    class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                                  >
                                    {item.item}
                                  </label>
                                </div>
                              </>
                            ) : (
                              <>
                                {' '}
                                <div className="flex items-center mb-4 ml-3">
                                  <input
                                    onChange={(e) =>
                                      setcaseDataSpecialLaw((caseDataSpecialLaw) => ({
                                        ...caseDataSpecialLaw,
                                        typeID: Number(e.target.value),
                                      }))
                                    }
                                    id="default-radio-1"
                                    type="radio"
                                    value={item.id}
                                    name="default-radio"
                                    className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300  dark:focus:ring-blue-600 dark:ring-offset-gray-800  dark:bg-gray-700 dark:border-gray-600"
                                  />
                                  <label
                                    for="default-radio-1"
                                    class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                                  >
                                    {item.item}
                                  </label>
                                </div>
                              </>
                            )}
                          </>
                        );
                      })}
                    </div>
                  </div>
                  <div className="w-full flex items-center justify-between">
                    {caseDataSpecialLaw.IsReplated ? (
                      <>
                        <div className="flex items-center mb-4">
                          <label
                            for="default-checkbox"
                            class="ms-2 text-sm font-[16px] text-gray-900 dark:text-gray-300 ml-3"
                          >
                            نسخ شده{' '}
                          </label>
                          <input
                            defaultChecked
                            onChange={(e) =>
                              setcaseDataSpecialLaw((caseDataSpecialLaw) => ({
                                ...caseDataSpecialLaw,
                                IsReplated: e.target.checked,
                              }))
                            }
                            id="default-checkbox"
                            type="checkbox"
                            value=""
                            className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                          />
                        </div>
                      </>
                    ) : (
                      <>
                        <div class="flex items-center mb-4">
                          <label
                            for="default-checkbox"
                            class="ms-2 text-sm font-[16px] text-gray-900 dark:text-gray-300 ml-3"
                          >
                            نسخ شده{' '}
                          </label>
                          <input
                            onChange={(e) =>
                              setcaseDataSpecialLaw((caseDataSpecialLaw) => ({
                                ...caseDataSpecialLaw,
                                IsReplated: e.target.checked,
                              }))
                            }
                            id="default-checkbox"
                            type="checkbox"
                            value=""
                            className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                          />
                        </div>
                      </>
                    )}
                  </div>
                  <div className="w-full flex items-center justify-between">
                    <label>وضعیت تایید:</label>
                    <select
                      onChange={OnchangeIsChecked}
                      className="border w-[100%] ml-5 border-[#E5E1DA] outline-none p-2 rounded-lg text-[14px]"
                    >
                      {caseDataSpecialLaw.isChecked == null ? (
                        <option value="null" selected></option>
                      ) : (
                        <option value="null"></option>
                      )}
                      {caseDataSpecialLaw.isChecked == true ? (
                        <option value="true" selected>
                          تایید
                        </option>
                      ) : (
                        <option value="true">تایید</option>
                      )}
                      {caseDataSpecialLaw.isChecked == false ? (
                        <option value="false" selected>
                          عدم تایید
                        </option>
                      ) : (
                        <option value="false">عدم تایید</option>
                      )}
                    </select>
                  </div>
                </div>
                <div className="w-full h-full flex items-center ltr gap-5 mt-10">
                  { Role?.role?.includes("SuperAdmin")|| Role?.role?.includes("Specialist") ? (
                    <button
                      onClick={upsertLawFun}
                      className="w-32 p-2  font-IranSans rounded-full flex items-center justify-center text-[16px] hover:border-2 text-white bg-[#65B741] font-bold 
              hover:shadow-2xl hover:shadow-black "
                    >
                      ثبت
                      <CiEdit size={25} className="ml-2" />
                    </button>
                  ):<></>}
        {FindIDInfoFetch.length!==0 &&  <Link target='_blank' to={`/information/${caseDataSpecialLaw.id}`}>
                <button
                    className="w-36 p-2  font-IranSans rounded-full flex items-center justify-center text-[14px] hover:border-2 text-white bg-[#fb7185] font-bold 
              hover:shadow-2xl hover:shadow-black "
                  >
                    {' '}
                    اطلاعات تنقیحی قانون{' '}
                  </button>
                </Link>}
                  {/* <button
                    className="w-32 p-2 rounded-full text-[16px] text-white flex items-center justify-center
             bg-[#867AE9] font-bold hover:border-2 hover:shadow-2xl hover:shadow-black font-IranSans"
                  >
                    جدید <IoNewspaperOutline className="ml-3" />
                  </button> */}
                  {/* <button
                    className="w-32 p-2  font-IranSans rounded-full text-[16px] text-white font-bold flex items-center justify-center
             bg-[#F5564E] hover:border-2 hover:shadow-2xl hover:shadow-black"
                  >
                    حذف
                    <MdDeleteForever className="ml-3" />
                  </button> */}
                </div>
              </div>
            </div>
          </div>
        )}
        {/* {openCeateModal && (
          <div className="ModalBackground">
            <div className="Modal-innerSpLaw">
              <FaRegWindowClose
                onClick={() => setOpenCreateModal(false)}
                className="  mb-2 cursor-pointer"
                size={18}
              />
              <div className="border   rounded-md p-5 border-[#cbd5e1]">
                <div className="w-full flex items-center  col-span-1	">
                  <label className="h-full w-[15%] text-[16px] flex items-center  font-IranSans">
                    عنوان :
                  </label>
                  <input
                    type="text"
                    className="w-[85%] border  outline-none  p-2 rounded-md"
                    // value={}
                    onChange={(e) =>
                      setcaseData((caseData) => ({
                        ...caseData,
                        title: e.target.value,
                      }))
                    }
                  />
                </div>
                <div className="w-full grid grid-cols-2 gap-10 mt-5 ">
                  <div className="w-full flex items-center justify-between">
                    <label className="h-full w-[30%] text-[14px] flex items-center justify-center font-IranSans">
                      مرجع تصویب :
                    </label>
                    <SearchableDropDownApprovalauthority
                      organID={caseData.ApprovalAuthority}
                    />
                   
                  </div>
                  <div className="w-full flex items-center justify-between">
                    <label className="h-full w-[30%] text-[14px] flex items-center justify-center font-IranSans">
                      مرجع تصویب2
                    </label>
                    <SearchableDropDownApprovalauthority2
                      organID={caseData.Approver2_ID}
                    />
                   
                  </div>
                  <div className="w-full flex items-center justify-between">
                    <label className="h-full w-[30%] text-[16px] flex items-center font-IranSans">
                      تاریخ تصویب :
                    </label>
                    <div className="w-full">
                      <DatePicker
                        className="custom-calendar"
                        inputClass="custom-input"
                        calendarPosition="bottom-center"
                        // value={caseData.date}
                        locale={persian_fa}
                        calendar={persian}
                        onChange={handleDate}
                      />
                    </div>
                  </div>
                  <div className="w-full flex items-center justify-between">
                    <label className="h-full w-[30%] text-[14px] flex items-center font-IranSans">
                      تاریخ تصویب2
                    </label>
                    <div className="w-full">
                      <DatePicker
                        className="custom-calendar"
                        inputClass="custom-input"
                        calendarPosition="bottom-center"
                        value={caseData.Approve2Date}
                        locale={persian_fa}
                        calendar={persian}
                        onChange={handleApproveDate2}
                      />
                    </div>
                  </div>
                  <div className="w-full flex items-center justify-between">
                    <label className="h-full w-[30%] text-[14px] flex items-center font-IranSans">
                      دسته بندی
                    </label>
                    <div className="w-full">
                      <select
                        onChange={(e) =>
                          setcaseData((caseData) => ({
                            ...caseData,
                            lawtypeID: Number(e.target.value),
                          }))
                        }
                        className="border w-[100%] ml-5 border-[#E5E1DA] outline-none p-2 rounded-lg text-[14px]"
                      >
                        {TypeList.map((item) => {
                          return item.ID == 8 ? (
                            <option value={item.ID} selected>
                              {item.Item}
                            </option>
                          ) : (
                            <option value={item.ID}>{item.Item}</option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                  <div className="w-full flex items-center justify-between">
                    <label className="h-full w-[30%] text-[14px] flex items-center font-IranSans">
                      نوع{' '}
                    </label>
                    <div className="w-full flex ">
                      {TypeIDList.map((item) => {
                        return (
                          <>
                            <div className="flex items-center mb-4 ml-3">
                              <input
                                onChange={(e) =>
                                  setcaseData((caseData) => ({
                                    ...caseData,
                                    typeID: Number(e.target.value),
                                  }))
                                }
                                id="default-radio-1"
                                type="radio"
                                value={item.ID}
                                name="default-radio"
                                className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300  dark:focus:ring-blue-600 dark:ring-offset-gray-800  dark:bg-gray-700 dark:border-gray-600"
                              />
                              <label
                                for="default-radio-1"
                                class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                              >
                                {item.Item}
                              </label>
                            </div>
                          </>
                        );
                      })}
                    </div>
                  </div>
                  <div className="w-full flex items-center justify-between">
                    <div class="flex items-center mb-4">
                      <label
                        for="default-checkbox"
                        class="ms-2 text-sm font-[16px] text-gray-900 dark:text-gray-300 ml-3"
                      >
                        نسخ شده{' '}
                      </label>
                      <input
                        onChange={(e) =>
                          setcaseData((caseData) => ({
                            ...caseData,
                            IsReplated: e.target.checked,
                          }))
                        }
                        id="default-checkbox"
                        type="checkbox"
                        value=""
                        className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      />
                    </div>
                  </div>
                  <div className="w-full flex items-center justify-between">
                    <label>وضعیت تایید:</label>
                    <select  onChange={OnchangeIsChecked} className="border w-[100%] ml-5 border-[#E5E1DA] outline-none p-2 rounded-lg text-[14px]">
                      <option value="null"></option>
                     {caseData.IsChecked ==true  ?  <option value="true" selected>تایید</option> :<option value="true">تایید</option>
                      }
                   {caseData.IsChecked ==false ?   <option value="false" selected>عدم تایید</option>:   <option value="false">عدم تایید</option>}
                    </select>
                  </div>
                </div>
                <div className="w-full h-full flex items-center ltr gap-5 mt-10">
                {jwtDecode(tokenLogin.data?.accessToken).role == "Admin" || jwtDecode(tokenLogin.data?.accessToken).role == "superAdmin" &&  <button
                    onClick={upsertLawFun}
                    className="w-32 p-2  font-IranSans rounded-full flex items-center justify-center text-[16px] hover:border-2 text-white bg-[#65B741] font-bold 
              hover:shadow-2xl hover:shadow-black "
                  >
                    ثبت
                    <CiEdit size={25} className="ml-2" />
                  </button>}
                
                </div>
              </div>
            </div>
          </div>
        )} */}
        {/* <div className="w-full mt-20 border-2 border-[#E5E1DA] rounded-lg p-5">
          <div className="w-full grid grid-cols-2  gap-5 p-3">
            <div className="w-full items-center flex ">
              <label
                className="ml-5 text-center flex items-center justify-center w-[20%] text-xl"
                style={{ fontFamily: 'Btitr' }}
              >
                عنوان
              </label>
              <input
                type="text"
                className="w-[80%] border-2 mt-5 outline-none border-body p-5 rounded-xl"
              />
            </div>
            <div className="w-full  items-center flex">
              <label
                className="ml-5 text-center flex items-center justify-center w-[20%] text-xl"
                style={{ fontFamily: 'Btitr' }}
              >
                مرجع تصویب
              </label>
              <select className="w-[80%] border-2 mt-5 outline-none border-body p-5 rounded-xl">
                <option>1</option>
                <option>2</option>
                <option>3</option>
              </select>
            </div>
            <div className="w-full flex  items-center  ">
              <label
                className="ml-5 text-center flex items-center justify-center w-[20%] text-xl"
                style={{ fontFamily: 'Btitr' }}
              >
                تاریخ تصویب
              </label>
             
              <DatePicker
                className="custom-calendar"
                inputClass="custom-input"
                calendarPosition="bottom-center"
                value={date}
                locale={persian_fa}
                calendar={persian}
                onChange={handleDate}
              />
              
            </div>
          </div>
          <div className=" flex gap-5 w-full mt-10 ltr p-5">
            <button
              className="w-40 p-2 rounded-lg text-2xl text-white font-bold
             bg-[#F5564E] hover:border-2 hover:shadow-2xl hover:shadow-black"
             
            >
              حذف
            </button>
            <button
              className="w-40 p-2 rounded-full text-2xl text-white flex items-center justify-center
             bg-[#867AE9] font-bold hover:border-2 hover:shadow-2xl hover:shadow-black"
            >
              جدید <IoNewspaperOutline className="ml-3" />
            </button>
            <button
              className="w-40 p-2 rounded-full flex items-center justify-center text-2xl hover:border-2 text-white bg-[#65B741] font-bold 
              hover:shadow-2xl hover:shadow-black "
            >
              ثبت
              <CiEdit size={30} className="ml-2" />
            </button>
          </div>
        </div> */}
      </div>
    </>
  );
};

export default Specificationslaw;
